export const SHOW_TRANSACT_POPUP = '[new transact] show modal';

export const TRANSACT_PAYMENT_SECTION = 'transact payment section';
export const TRANSACT_INCENTIVES_SECTION = 'transact incentives section';
export const TRANSACT_TRADE_SECTION = 'transact trade section';
export const TRANSACT_TAX_SECTION = 'transact tax section';
export const TRANSACT_CREDIT_SECTION = 'transact credit section';
export const TRANSACT_SERVICE_PROTECTION_SECTION = 'transact service protection section';
export const TRANSACT_ACCESSORIES_SECTION = 'transact accessories section';
export const TRANSACT_CHECKOUT_SECTION = 'transact checkout section';

export const TRANSACT_VIEW_PORT_SECTIONS = [
  TRANSACT_PAYMENT_SECTION,
  TRANSACT_INCENTIVES_SECTION,
  TRANSACT_TRADE_SECTION,
  TRANSACT_TAX_SECTION,
  TRANSACT_CREDIT_SECTION,
  TRANSACT_SERVICE_PROTECTION_SECTION,
  TRANSACT_ACCESSORIES_SECTION,
  TRANSACT_CHECKOUT_SECTION,
];
